import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import ReimbursementForm, {
    ReimbursementClaimFormProps
} from "../../../pages/reimbursements/components/claims/ReimbursementForm";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, ReimbursementClaimFormProps {
}

type Props = OwnProps;

// @ts-ignore
const ReimbursementClaimModal = NiceModal.create<Props>(({reimbursementClaim, onClose, header,...rest}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <ReimbursementForm reimbursementClaim={reimbursementClaim} {...rest}/>
        </SlideOver>
    )
})

export default ReimbursementClaimModal;
